﻿//全站用
function HolidayNoticeShowAllWebsite() {
	if (typeof (window.holidayInfo) !== 'undefined') {
		var holidayInfo = window.holidayInfo;
        if (holidayInfo.IsAllWebsite === 'true') {
            var showBool = true;
            if (window.CountryCode.toLocaleLowerCase() === "cn") {
                if (location.pathname !== "/") {
                    showBool = false;
                } 
            }
            if (showBool) {
                HolidayNotice();
            }
			
		}
	}
}
//Support Page用
function HolidayNoticeShowOnePage() {
	if (typeof (window.holidayInfo) !== 'undefined') {
		var holidayInfo = window.holidayInfo;
		if (holidayInfo.IsAllWebsite === 'false') {
			HolidayNotice();
		}
	}
}

function HolidayNotice() {
	if (typeof (window.holidayInfo) !== 'undefined') {
		var holidayInfo = window.holidayInfo;

		var today = getFormattedTime();
		//alert(today);
		if (typeof (today) !== "undefined") {
			today = new Date(today);
		}

		var starttime = holidayInfo.HolidayStart === ""
			? today
			: holidayInfo.HolidayStart;
		
		var endtime = holidayInfo.HolidayEnd;
		if (typeof (starttime) !== 'undefined' && typeof (endtime) !== 'undefined') {
			//alert(Date.parse(starttime).valueOf());
			if (Date.parse(starttime).valueOf() <= today && today < Date.parse(endtime).valueOf()) {
				setTimeout(function () {
					CheckHolidayCookie();
				}, 500);

				$(document).on('click', '.btn-ok,.wrap-close,.wrap-email', function () {
					$.unblockUI();
				});
			}
		}
	}
}

function CheckHolidayCookie() {
	var hasHolidayClosed = CookieWithCountryCode.get("HasHolidayClosed");

	if (hasHolidayClosed === null) {
		ShowHolidayTips();
	}
}

function ShowHolidayTips() {
	var wrap = $("<div></div>").addClass("wrap");
	var spanwrap = $("<p></p>").addClass("wrap-close");
	var iClose = $("<img/>").attr("src", "/Images/Object/close.png");
	spanwrap.append(iClose);
	wrap.append(spanwrap);
	var text = $("<div></div>").addClass("Text");
	text.append(window.holidayInfo.HolidayContent);
	wrap.append(text);
	var okButton = $("<a></a>").addClass("btn-asus btn-ok").append("OK");
	wrap.append(okButton);

	var conuntry = window.isTW
		? "tw" : "";
	var message = $("<div style='display:none' id='HolidayTipDiv' class='" + conuntry + "'></div>");
	message.append(wrap);
	//ShowHolidayBlockUi(message, wrap);
	ShowHolidaySimpleModel(message);
}

function ShowHolidayBlockUi(message, wrap) {
	var blockUiWidth = "50%";
	var topValue = "30%";
	var leftValue = 0;
	var marginTopValue = "0";
	var postitionValue = "fixed";
	var zIndexValue = '10000';

	if (typeof ($(window).width()) !== 'undefined') {

		leftValue = ($(window).width() - ($(window).width() * 0.5)) / 2;

		//RWD
		if ($(window).width() < 961) {
			blockUiWidth = '100%';
			topValue = "25%";
			leftValue = 0;
			marginTopValue = '20%';
			postitionValue = 'absolute';
			zIndexValue = '1000000';
		}
	}

	$.blockUI({
		message: message,
		css: {
			top: topValue,
			left: leftValue,
			width: blockUiWidth,
			centerX: true,
			centerY: true,
			textAlign: 'left',
			marginTop: marginTopValue,
			position: postitionValue,
			zIndex: zIndexValue
		}
	});

	$("#HolidayTipDiv").html(wrap);
	//更改為必須點擊ok才會不再顯示
	$("#HolidayTipDiv").find(".btn-ok").off('click').on('click', function () {
		CookieWithCountryCode.set("HasHolidayClosed", "1", "false", 1);
	});
	$('.blockOverlay').attr('title', 'Click to unblock').click($.unblockUI);
}

function ShowHolidaySimpleModel(message) {
	$(".topBg").append(message);
	var modalOptions = {
		containerCss: {
			dispaly: "flexed",
			top: "20%",
			left: "2%",
			backgroundColor: "#fff",
			border: 0,
			padding: 0,
			maxHeight:$("#HolidayTipDiv").height()
			//overflow: "visible"
		},
		//closeHTML: '<span class="wrap-close"><img src="/Images/Object/close.png" /></span>',
		overlayCss: { "background-color": "#000000" },
		fixed: false,
		onOpen:
			function (dialog) {
				dialog.data.show();
				dialog.overlay.fadeIn('fast',
					function () {
						dialog.container.fadeIn();
						$(".wrap-close").click(function () {
							$.modal.close();
							 if (window.CountryCode.toLocaleLowerCase() === "cn") {
									if (location.pathname === "/") {
										CookieWithCountryCode.set("HasHolidayClosed", "1", "false", 1);
									} 
								}
						});
						$("#simplemodal-overlay").click(function () {
							$.modal.close();
						});
						//更改為必須點擊ok才會不再顯示
						$("#HolidayTipDiv").find(".btn-ok").off('click').on('click', function () {
							CookieWithCountryCode.set("HasHolidayClosed", "1", "false", 1);
							$.modal.close();
						});
						
					});
			},
		zIndex: 99999,
		onClose: function (dialog) {
			dialog.container.fadeOut(function () {
				dialog.data.hide();
				dialog.overlay.fadeOut('fast',
					function () {
						$.modal.close();
					});
			});
		},
		onShow: function (dialog) {
			RwdCheckSize(dialog.container);
			$(window).resize(function () {
				RwdCheckSize(dialog.container);
			});
		},
		autoResize: true,
		overlayClose: false
	};
	$("#HolidayTipDiv").modal(modalOptions);
}

//--RWD Resize
function RwdCheckSize(popArea) {
	if ($(window).width() <= window.RwdWid) {
		popArea.css('width', '96%');
		popArea.css('left', '2%');
	} else {
		popArea.css('width', '45%');
		popArea.css('left', '27%');
	}
	setTimeout(function () {
		$(".simplemodal-wrap").css("height", $("#HolidayTipDiv").height());
	}, 500);
}